import { motion } from "framer-motion";
import {useRef} from 'react';

function Fun() {
    const constraintsRef = useRef(null);

    return(
        <motion.div ref={constraintsRef}>
            <h2 class="header">⚡ Fun facts</h2>
            <div className="row">
                <motion.div class="col s12 m3 l3" drag
                    dragConstraints={constraintsRef}>                
                    <div class="card horizontal">
                    <div class="card-stacked">
                    <div class="card-content materialize-red lighten-5">
                    <p>I started going to the gym three years ago and have been going consistently ever since, never regret stopping restrictive diet and opting for the gains <span className="blue-text">#StrongWomen</span></p>
                    </div>
                    </div>
                    </div>
                </motion.div>
                <motion.div class="col s12 m3 l3" drag
                    dragConstraints={constraintsRef}>                   
                    <div class="card horizontal">
                    <div class="card-stacked">
                    <div class="card-content orange lighten-5">
                    <p>I am obsessed with birds, by that I mean OBSSESSED. Seeing cute bird (or pictures of them) never fails to cheer me up 🐦</p>
                    </div>
                    </div>
                    </div>
                </motion.div>
                <motion.div class="col s12 m3 l3" drag
                    dragConstraints={constraintsRef}>                   
                    <div class="card horizontal">
                    <div class="card-stacked">
                    <div class="card-content blue lighten-5">
                    <p>I have a hummingbird feeder and enjoy looking at those nimble little buggers. I recently moved and the birds have not 
                        discovered my place yet but I'm patient
                    </p>
                    </div>
                    </div>
                    </div>
                </motion.div>
                <motion.div class="col s12 m3 l3" drag
                    dragConstraints={constraintsRef}>                   
                    <div class="card horizontal">
                    <div class="card-stacked">
                    <div class="card-content purple lighten-5">
                    <p>I subscribe to technology newsletters and get inspirations from them for project and research ideas🤓
                    </p>
                    </div>
                    </div>
                    </div>
                </motion.div>
            </div>
            <div className="row">
                <motion.div class="col s12 m3 l3" drag
                    dragConstraints={constraintsRef}>                   
                    <div class="card horizontal">
                    <div class="card-stacked">
                    <div class="card-content cyan lighten-5">
                    <p>I make sure to get at least 8 hours of sleep everyday and never pull all nighters (this might change when in-person hackathons return tho!) 😴 
                    </p>
                    </div>
                    </div>
                    </div>
                </motion.div>
                <motion.div class="col s12 m3 l3" drag
                    dragConstraints={constraintsRef}>                   
                    <div class="card horizontal">
                    <div class="card-stacked">
                    <div class="card-content teal lighten-5">
                    <p>I enjoy a good sci-fi novel and would sometimes read for hours at a time 📚 My favourite author is Isaac Asimov, I had to get the second volume of his
                        complete stories (now discontinued) from EBay.
                    </p>
                    </div>
                    </div>
                    </div>
                </motion.div>
                <motion.div class="col s12 m3 l3" drag
                    dragConstraints={constraintsRef}>                   
                    <div class="card horizontal">
                    <div class="card-stacked">
                    <div class="card-content deep-orange lighten-5">
                    <p>I&#39;m a skincare junkie, I have researched about skincare ingredients and now maintains a low budget but highly effective routine that leaves me with glowing skin
                    </p>
                    </div>
                    </div>
                    </div>
                </motion.div>
            </div>
        </motion.div>
    );
}

export default Fun